import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { css } from '@emotion/css';
import { corporateBlue, corporateGreyLight } from '../assets/colors';

/**
 * @brief Renders a box with a fontawesome icon, a title and a short text.
 */
const OverviewBox = (props) => {
    return (
        <div
            className={css({
                width: '100%',
                height: '15mm',
                display: 'flex',
                flexDirection: 'row',
                marginTop: 0,
                pageBreakInside: 'avoid',
                '& + &': {
                    marginTop: '1.5mm',
                },
            })}
        >
            <div
                className={css({
                    height: '15mm',
                    fontSize: '11mm',
                    color: corporateBlue,
                    marginRight: '2mm',
                })}
            >
                <FontAwesomeIcon icon={['fas', props.icon]} fixedWidth />
            </div>
            <div
                className={css({
                    padding: '1.5mm 2mm',
                    backgroundColor: corporateGreyLight,
                    flexGrow: 1,
                })}
            >
                <div
                    className={css({
                        fontWeight: 'bold',
                    })}
                >
                    {props.title}
                </div>
                <div
                    className={css({
                        lineHeight: '105%',
                    })}
                >
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default OverviewBox;
